import React from "react";
import { Provider } from "react-redux";
import { IntlProvider } from "react-intl";
import { createStore, combineReducers } from "redux";
import { MSCQReducerNew } from "@learningblocks/exp-redux";
import QuestionTableReducer from "@learningblocks/simulations/shared-components/lib/Questions/QuestionTableRedux/store/reducer";
import { HighlightProvider } from "@learningblocks/shared-components";

// Create Redux store for MultiSelectRedux support
const rootReducer = combineReducers({
  mscq: MSCQReducerNew, // Required for MultiSelectRedux component
  questionTable: QuestionTableReducer,
});

const store = createStore(rootReducer);

interface ImageHotspotProvidersProps {
  children: React.ReactNode;
  locale: string;
  messages: Record<string, string>;
  usersnapProvider?: React.ComponentType<any>;
  usersnapProps?: any;
}

export function ImageHotspotProviders({
  children,
}: ImageHotspotProvidersProps): React.JSX.Element {
  const content = <Provider store={store}>{children}</Provider>;
  return content;
}

// Export types for convenience
export type { ImageHotspotProvidersProps };
